var chunkMapping = {
	"70": [
		3070
	],
	"231": [
		3231
	],
	"271": [
		5271
	],
	"343": [
		7343
	],
	"369": [
		3369
	],
	"435": [
		4816
	],
	"464": [
		3464
	],
	"596": [
		1596
	],
	"639": [
		6639
	],
	"770": [
		330,
		421,
		5534,
		5711,
		6435
	],
	"786": [
		5786
	],
	"803": [
		8803
	],
	"921": [
		6921
	],
	"998": [
		7525,
		9166
	]
};
var idToExternalAndNameMapping = {
	"330": [
		"default",
		"./generic/components/general/toast",
		5197
	],
	"421": [
		"default",
		"./generic/helpers/google-tag-manager",
		5197
	],
	"1596": [
		"default",
		"./generic/components/cards/card-news",
		5197
	],
	"3070": [
		"default",
		"./generic/components/general/sheet",
		5197
	],
	"3231": [
		"default",
		"./generic/components/navigation/sub-header",
		5197
	],
	"3369": [
		"default",
		"./generic/components/general/rich-text",
		5197
	],
	"3464": [
		"default",
		"./generic/components/cards/player-card",
		5197
	],
	"4816": [
		"default",
		"./generic/components/general/card-slider",
		5197
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		5197
	],
	"5534": [
		"default",
		"./generic/elements/menu-item",
		5197
	],
	"5711": [
		"default",
		"./generic/elements/info-block",
		5197
	],
	"5786": [
		"default",
		"./mancity/components/general/seo",
		5197
	],
	"6435": [
		"default",
		"./generic/components/profile/avatar",
		5197
	],
	"6639": [
		"default",
		"./players/components/hero-player",
		5197
	],
	"6921": [
		"default",
		"./generic/elements/loading",
		5197
	],
	"7343": [
		"default",
		"./generic/elements/button",
		5197
	],
	"7525": [
		"default",
		"./generic/components/general/tabs",
		5197
	],
	"8803": [
		"default",
		"./generic/components/navigation/pagination",
		5197
	],
	"9166": [
		"default",
		"./generic/elements/divider",
		5197
	]
};
var idToRemoteMap = {
	"330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"421": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1596": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3070": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3231": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3369": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3464": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"4816": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5534": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5786": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6639": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7525": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8803": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9166": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"421": {
		"shareScope": "default",
		"name": "./generic/helpers/google-tag-manager",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"1596": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-news",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"3070": {
		"shareScope": "default",
		"name": "./generic/components/general/sheet",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"3231": {
		"shareScope": "default",
		"name": "./generic/components/navigation/sub-header",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"3369": {
		"shareScope": "default",
		"name": "./generic/components/general/rich-text",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"3464": {
		"shareScope": "default",
		"name": "./generic/components/cards/player-card",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"4816": {
		"shareScope": "default",
		"name": "./generic/components/general/card-slider",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"5534": {
		"shareScope": "default",
		"name": "./generic/elements/menu-item",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"5711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"5786": {
		"shareScope": "default",
		"name": "./mancity/components/general/seo",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"6435": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"6639": {
		"shareScope": "default",
		"name": "./players/components/hero-player",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"6921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"7343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"7525": {
		"shareScope": "default",
		"name": "./generic/components/general/tabs",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"8803": {
		"shareScope": "default",
		"name": "./generic/components/navigation/pagination",
		"externalModuleId": 5197,
		"remoteName": "core"
	},
	"9166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 5197,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}